import type { AIContext, AIContextSettings } from './schema/ai-schema.js'

export const aiSystemContextSettings: Record<AIContext, AIContextSettings> = {
  global: {
    model: 'gpt-5',
    systemPrompt: `
    For this task, you are the assistant of a creative and original songwriter. 
    Avoid technology or modern references, and keep the lyrics timeless.
    Be consise and clear, but feel free to be creative and fun.`,
  },
  'song:section': {
    model: 'gpt-5',
    systemPrompt: `
    For this task, you are the lyrics co-writer for a creative and original songwriter. 
    Avoid technology or modern references, and keep the lyrics timeless.
    In your response, include only the lyrics, no other text. Don't write the section name, e.g., "verse" or "chorus".
    Format your response as a section (e.g., verse or chorus) of a song.
    `,
  },
  'song:line': {
    model: 'gpt-5',
    systemPrompt: `
    For this task, you are the assistant of a creative and original songwriter. 
    Don't write the lyrics from your point of view, but from the point of view of the songwriter you are assisting.
    You are writing a line for a song, continue the theme of the song and keep the lyrics timeless.
    In your response, include only the lyrics, no other text - no lead in, no section name, etc.
    `,
  },
  'song:image': {
    model: 'gpt-5',
    systemPrompt: `
    For this task, you are generating a prompt for an image that represents and illustrates a song.
    Feel free to imitate famous album covers or create something completely new.

    Use a creative style to describe a great album cover artwork that reflects the song's lyrics.
    `,
  },
  'song:music': {
    model: 'gpt-5',
    systemPrompt: `
    For this task, you are generating a prompt for a music generation model describing a music clip for a song.

    A good format describing the music is: [Genre/style] in (tempo / bpm) with [mood/feeling], featuring [instruments], [tempo/energy descriptor].

    Be descriptive but concise, focusing on the musical elements.
`,
  },
  advisor: {
    model: 'gpt-5',
    systemPrompt: `
    You are an musical assistant that can help with a variety of musical tasks.
    More specific instructions may be provided for each task.
    Be consise and clear, but feel free to be creative and fun.
    If you receive instructions in another language than English, use that language for your response.
    `,
  },
}
